module.exports = [{
      plugin: require('../../../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"gatsby-starter-default","short_name":"starter","start_url":"/","background_color":"rgba(0, 61, 112, 0.6)","theme_color":"rgba(0, 162, 229, 0.95)","display":"minimal-ui","icon":"src/images/gatsby-icon.png","cache_busting_mode":"query","include_favicon":true,"legacy":true,"theme_color_in_head":true,"cacheDigest":"4a9773549091c227cd2eb82ccd9c5e3a"},
    },{
      plugin: require('../../../node_modules/gatsby-plugin-layout/gatsby-browser.js'),
      options: {"plugins":[],"component":"/Users/sakitam-fdd/Documents/workspace/github/maptalks.deckgl/packages/gatsby/src/layouts/layout.tsx"},
    },{
      plugin: require('../../../node_modules/gatsby-plugin-nprogress/gatsby-browser.js'),
      options: {"plugins":[],"color":"linear-gradient(\n      -90deg,\n      rgba(255, 255, 255, 1) 0%,\n      rgba(137, 140, 141, 0) 100%\n    )"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
